import { useRouteLoaderData } from "react-router";

import type { RootLoaderData } from "~/root";

export const useRootData = () => useRouteLoaderData<RootLoaderData>("root");
